.button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid transparent;
  border-radius: var(--radius);
  font-weight: 650;
  cursor: pointer;
  white-space: nowrap;
  transition:
    transform 0.18s var(--ease-out),
    box-shadow 0.18s var(--ease-out),
    background 0.18s,
    opacity 0.18s;
}

.button:hover:not(:disabled) {
  transform: translateY(-2px);
}

.button:active:not(:disabled) {
  transform: translateY(0) scale(0.98);
}

.button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.regular {
  padding: 13px 20px;
  font-size: 1rem;
}

.small {
  padding: 7px 12px;
  font-size: 0.875rem;
  border-radius: var(--radius-small);
}

.primary {
  background: linear-gradient(180deg, var(--color-accent-strong), var(--color-accent));
  color: var(--color-accent-ink);
  box-shadow:
    0 10px 24px rgb(232 184 79 / 0.28),
    0 1px 0 rgb(255 255 255 / 0.5) inset;
}

.primary:hover:not(:disabled) {
  box-shadow:
    0 14px 30px rgb(232 184 79 / 0.4),
    0 1px 0 rgb(255 255 255 / 0.5) inset;
}

.secondary {
  background: var(--color-surface-strong);
  border-color: var(--color-border);
}

.secondary:hover:not(:disabled) {
  background: rgb(255 255 255 / 0.16);
}

.ghost {
  background: transparent;
  color: var(--color-text-muted);
}

.ghost:hover:not(:disabled) {
  color: var(--color-text);
  background: var(--color-surface);
}
